import { Styles } from 'react-jss'

export const sheet: Styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9998
  },
  modal: {
    position: 'relative',
    maxWidth: '90%',
    boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
    animation: 'fadeIn 0.25s ease-out'
  },
  closeBtn: {
    // position: 'absolute',
    // top: 12,
    // right: 16,
    background: 'none',
    border: 'none',
    fontSize: 20,
    cursor: 'pointer',
    color: '#555',
    '&:hover': {
      color: '#000'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '16px'
  },
  paddingTitle: {},

  content: {},
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'scale(0.95)' },
    to: { opacity: 1, transform: 'scale(1)' }
  }
}
